import { Paper, Stack, Switch, Text } from "@mantine/core";
import { useQueryClient } from "@tanstack/react-query";

import {
  getGetAppearanceQueryKey,
  useGetAppearance,
  useUpdateTeamAppearance,
} from "../../api/generated/endpoints/appearance/appearance";
import { ErrorAlert } from "../ErrorAlert";

/**
 * The team's switch for the free daily case (Daniil, 2026-10-28: teams, "especially the admin of the
 * whole team, can hide the cases"), for its owner and admins: off hides the case and its gift icon
 * for every member, who keep the themes they won (spec web/case-switches).
 */
export function TeamCaseSwitch({ teamId }: { teamId: string }) {
  const queryClient = useQueryClient();
  const view = useGetAppearance(teamId).data;
  const update = useUpdateTeamAppearance({
    mutation: { onSettled: () => queryClient.invalidateQueries({ queryKey: getGetAppearanceQueryKey(teamId) }) },
  });
  if (view === undefined) return null;
  return (
    <Paper withBorder radius="lg" p="md">
      <Stack gap="xs">
        <Text fw={600} size="sm">
          Free daily case
        </Text>
        <Switch
          label="Offer the free daily case to members"
          description="Off hides the case and its gift icon for everyone in this team. The themes members won stay theirs."
          checked={!view.team_cases_hidden}
          disabled={update.isPending}
          onChange={(event) => update.mutate({ teamId, data: { cases_hidden: !event.currentTarget.checked } })}
        />
        {update.isError ? <ErrorAlert error={update.error} /> : null}
      </Stack>
    </Paper>
  );
}
